export enum JobPostingInterviewOpinionScaleTypes {
    numerical = 'Numerical',
    stars = 'Stars',
}
